export const SERVICE_TYPES = {
    service: 'service',
    cloud: 'cloud',
    manual: 'manual'
};

export const LOGO_TYPES = {
    large: 'large',
    medium: 'medium',
    small: 'small'
};

export const groupArrayByNumber = function (array = [], step = 1) {
    const arrayOfArray = [];
    let innerArray = [];
    const length = array.length;

    for (let i = 0; i < length; i += step) {

        for (let j = 0; j < step; j++) {
            const innerEl = array[i + j];
            if (innerEl !== undefined) innerArray.push(array[i + j]);
        }

        arrayOfArray.push(innerArray)
        innerArray = [];
    }

    return arrayOfArray;
}

groupArrayByNumber(Array.from({length: 10}, (_, i) => i), 3);
